import { z } from 'zod';

import { LosId, UserId } from '../../BrandedIds';
import { zodTemporalInstant } from '../../Temporal';
import { zodBrandedString } from '../../utils';

export const ExportablePointOfContact = z
  .object({
    loanId: zodBrandedString<LosId>(),
    userId: zodBrandedString<UserId>(),
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'PointOfContact' });
export type ExportablePointOfContact = z.infer<typeof ExportablePointOfContact>;
